export const ContentWidthMixin = {
    data() {
        return {
            collapse: false,
            mixinOriginWidth: 0
        }
    },
    computed: {
        mixinCardStyle() {
            return {
                width: `${(this.mixinOriginWidth - 30) / 3}px`
            };
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
        });
    },
    mounted() {
        this.mixinInitContentWidth();
    },
    watch: {
        collapse() {
            setTimeout(() => {
                this.mixinInitContentWidth();
            }, 350);
        }
    },
    methods: {
        mixinInitContentWidth() {
            if (this.$el) {
                const {width} = this.$el.getBoundingClientRect();
                this.mixinOriginWidth = width;
            } else {
                setTimeout(() => {
                    this.mixinInitContentWidth();
                }, 20);
            }
        }
    },
}